<template>
  <div class="">
    <div v-if="isShow" class="pt16 pb16 bg_white">
      <PageBack class="pl16" />
      <SectionTitle
      class="mt16"
      :title="'売上レポート'"
      :width="'116'"
      />
      <SelectMonth />
      <div class="access_wrap mt16 ml32 mr16">
        <dl class="access_table">
          <div class="table_list bdb large">
            <dt class="table_title rb">キャッシュバック</dt>
            <dd class="table_text rb">{{ cashBackAmount.toLocaleString() }}</dd>
          </div>
        </dl>
        <p v-if="affiliateItemId != 'HCC'" class="alert_text mt5 ab c5a">※キャッシュバックはNP会員の購入分も含みます</p>
      </div>

      <h1 class="access_title mr16 mt24 rb" :style="styleColor(color)">{{ affiliateItemName }}LPアクセス状況</h1>
      <div class="access_wrap mt16 ml32 mr16">
        <dl class="access_table">
          <div class="table_list bdb">
            <dt class="table_title rb">アクセス人数</dt>
            <dd class="table_text rb">{{ numberOfVisitor }}</dd>
          </div>
          <div class="table_list bdb">
            <dt class="table_title rb">購入人数</dt>
            <dd class="table_text rb">{{ numberOfPurchaser }}</dd>
          </div>
          <div class="table_list bdb">
            <dt class="table_title rb">購入数</dt>
            <dd class="table_text rb">{{ numberOfProductPurchase }}</dd>
          </div>
          <div class="table_list bdb">
            <dt class="table_title rb">売上</dt>
            <dd class="table_text rb">{{ salesAmount.toLocaleString() }}</dd>
          </div>
          <p v-if="affiliateItemId == 'HCC'" class="alert_text mt5 ab c5a">※代引購入分は、製品お受け取り後に反映されます。</p>
          <!-- <div class="table_list bdb">
            <dt class="table_title rb">キャッシュバック</dt>
            <dd class="table_text rb">{{ cashBackAmount.toLocaleString() }}</dd>
          </div> -->
        </dl>
      </div>
      <h2 class="page_title ab mt40 ml16 mr16">LPアクセス人数</h2>
      <div class="access_graph mt16 ml16 mb24 mr16">
        <ChartAccess :affiliateSalesSummaryDetailDailyList="affiliateSalesSummaryDetailDailyList" />
      </div>
      <h2 class="page_title ab ml16 mt20 mr16">LP購入人数</h2>
      <div class="access_detail mt16 ml16 mr16">
        <div v-if="val.numberOfPurchaser > 0" v-for="(val, index) in affiliateSalesSummaryDetailDailyList" class="detail_wrap" :key="index">
          <router-link :to="{ name: 'WalletNdsDetail', query: { affiliateProductId: val.affiliateItemId, targetYmd: val.targetYear + '-' + val.targetMonth + '-' + val.targetDay } }" class="detail_contents detail_contents_02" :key="val.targetYear + '-' + val.targetMonth + '-' + val.targetDay">
            <div class="detail_date rr">{{ val.targetDay }}<span class="date">日</span></div>
            <div class="detail_data rr">
              <p class="detail_link">{{ val.numberOfPurchaser }}</p>
            </div>
          </router-link>
        </div>
      </div>
      <ErrorModal v-if="isErrorModal" :errorMessage="errorMessage" @modalClose="modalClose" />
    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
  </div>
</template>

<script>
import Check from '@/model/getToken';
import Wallet from '@/components/api/wallet/wallet';
import SectionTitle from '@/components/common/SectionTitle';
import SelectMonth from '@/components/wallet/SelectMonth';
import PageBack from '@/components/wallet/PageBack';
import ChartAccess from '@/components/wallet/ChartAccessDetail';
import { mapGetters } from 'vuex';
import ErrorModal from '@/components/common/ErrorModal';

export default {
  components: {
    SectionTitle,
    SelectMonth,
    PageBack,
    ChartAccess,
    ErrorModal
  },
  data() {
    return {
      isShow: true,
      affiliateItemId: null,
      affiliateItemName: null,
      affiliateSalesSummaryDetailDailyList: [],
      cashBackAmount: 0,
      numberOfProductPurchase: 0,
      numberOfPurchaser: 0,
      numberOfVisitor: 0,
      salesAmount: 0,
      targetMonth: 0,
      targetYear: 0,
      isErrorModal: false,
      errorMessage: '',
      color: '',
    }
  },
  methods: {
    styleColor(color) {
      return "background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), " + color ;
    },
    modalClose() {
      this.isErrorModal = false;
    },
    sliceAffiliateSalesSummaryDetailDailyList(array, number) {
      const length = Math.ceil(array.length / number)
      return new Array(length).fill().map((_, i) =>　array.slice(i * number, (i + 1) * number));
    },
    async getSalesSummaryDetailMonthly() {
      console.log(this.$route.query.affiliateProductId);
      await Wallet.getSalesSummaryDetailMonthly(this.$route.query.affiliateProductId, this.currentMonth).then((val) => {
        console.log('商品別マンスリーデータ');
        console.log(val);
          this.affiliateItemId = val.affiliateItemId;
          this.affiliateItemName = val.affiliateItemName;

          this.cashBackAmount = val.cashBackAmount;
          this.numberOfProductPurchase = val.numberOfProductPurchase;
          this.numberOfPurchaser = val.numberOfPurchaser;
          this.numberOfVisitor = val.numberOfVisitor;
          this.salesAmount = val.salesAmount;
          this.targetMonth = val.targetMonth;
          this.targetYear = val.targetYear;

          this.affiliateSalesSummaryDetailDailyList.splice(0, this.affiliateSalesSummaryDetailDailyList.length);
          this.affiliateSalesSummaryDetailDailyList.push(...val.affiliateSalesSummaryDetailDailyList);

          this.color = val.color;
      });
    },
  },
  computed: mapGetters(['currentMonth']),
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      this.getSalesSummaryDetailMonthly();
      // this.horizontalBar();
    } else {
      this.isShow = false;
    }
  },
  watch: {
    currentMonth() {
      this.getSalesSummaryDetailMonthly();
    }
  }
}
</script>

<style lang="css" scoped>
.mychart {
  margin-bottom: 40px;
  width: 100%;
}
.access_title {
  align-items: center;
  /* background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), #4F68D4; */
  border-radius: 0 100px 100px 0;
  color: #fff;
  display: flex;
  justify-content: space-between;
  padding: 12px 48px 12px 16px;
  position: relative;
}

.table_list {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 16px 0 8px;
}

.table_list.large .table_title,
.table_list.large .table_text {
  font-size: 18px;
}

.access_detail {
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}
.detail_wrap {
  width: calc(33% - 8px);
  /* width: 32.5%; */
}
.detail_wrap:not(:nth-child(3n + 1)) {
   /* margin-right: 8px; */
   margin-left: 8px;
}
.detail_contents {


}
.detail_contents_01 {
  align-items: center;
  border: 1px solid #5A5A5A;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;
  padding: 7.5px 0;
}
.detail_date {
  font-size: 14px;
}
.detail_date .date {
  font-size: 12px;
}
.detail_link {
  color: #6E74FF;
  font-size: 16px;
  text-decoration: underline;
}

.detail_contents_02 {
  display: flex;
  border: 1px solid #53CDD5;
  border-radius: 8px;
  margin-bottom: 12px;
  overflow: hidden;
}
.detail_contents_02 .detail_date {
  background: #53CDD5;
  color: #fff;
  padding: 6px 0;
  text-align: center;
  width: 38.2%;
}
.detail_contents_02 .detail_data {
  max-width: 68px;
  padding: 6px 0;
  text-align: center;
  width: 61.8%;
}
.alert_text {
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// src/views/wallet/salesSummaryReport/AccessDetail.vue